module Bookhus {
    var translations = {
        loadingproperties: {
            da: 'Henter flere emner',
            'en-GB': 'Loading more properties',
            sv: 'Hämtar fler ämnen',
            de: 'Ruft weitere Themen ab',
            no: 'Henter flere emner'
        }
    };

    export type InfiniteOptions = {
        basePath: string;
        path: string;
        scrollThreshold: number;
        pageStart: number;
        loaderSelector: string;
        loadCallback: Function
    }

    export class InfiniteScroll {
        private element: JQuery;
        private options: InfiniteOptions;
        private currentPage: number;
        private isLoading: boolean = false;
        private canLoad: boolean = true;

        private culture: string = $.datepicker.regional.bookhuscurrent;

        constructor(element: JQuery, options: Partial<InfiniteOptions> = {}) {
            this.element = element;
            this.options = $.extend({
                basePath: '/',
                scrollThreshold: 400,
                pageStart: 1
            }, options) as any;

            if (!this.options.path) {
                console.log('Path needs to be specified');
                return;
            }

            this.initEvents();
        }

        public resetPosition(): void {
            this.currentPage = undefined;
            this.canLoad = true;
        }

        private initEvents() {
            $(window).on('scroll', this.throttle(() => {
                var distance = this.getBottomDistance();
                if (distance <= this.options.scrollThreshold) {
                    this.loadNextPage();
                }
            }, 500));
        }

        private loadNextPage(): void {
            var self = this;
            if (this.isLoading || !this.canLoad) {
                return;
            }

            this.isLoading = true;
            var loaderElement = this.getLoader();
            this.element.append(loaderElement);

            var nextPage = this.currentPage + 1 || this.options.pageStart;

            $.ajax({
                url: self.options.basePath + self.options.path + `?id=${nextPage}&infinityScroll=true`,
                type: 'get',
                success: function (body, statusText, xhr) {
                    loaderElement.remove();
                    self.isLoading = false;
                    self.element.append(body);
                    self.currentPage = nextPage;
                    if (xhr.status == 204) {
                        //We have reached last page
                        self.canLoad = false;
                    }
                    if (self.options.loadCallback) {
                        self.options.loadCallback();
                    }
                },
                error: function (xhr) {
                    
                }
            });
        }

        private getBottomDistance(): number {
            var bottom = this.element.position().top + this.element.outerHeight();
            var scrollY = (window.scrollY || window.pageYOffset) + window.innerHeight;
            return bottom - scrollY;
        }

        private getLoader(): JQuery {
            if (this.options.loaderSelector) {
                return $(this.options.loaderSelector);
            }
            return $(`
                <div class="loaderWrap text-center pt-5 pb-5 mt-5 mb-5">
				    <div class="fa fa-spinner fa-spin h1">
				    </div>
				    <p class="iconColor">${translations.loadingproperties[this.culture]}</p>
			    </div>
            `);
        }

        private throttle(fn, threshold?: number) {
            threshold = threshold || 200;

            var last, timeout;
            return function () {
                var now = +new Date(), args = arguments, context = this;

                var trigger = () => {
                    last = now;
                    fn.apply(context, args);
                }
                if (last && now < last + threshold) {
                    clearTimeout(timeout);
                    timeout = setTimeout(trigger, threshold);
                }
                else {
                    trigger();
                }
            }
        }
    }
}

($ => {
    const pluginName = 'bookhus_infinity_scroller';
    $.fn.InfiniteScroll = function (options: Partial<Bookhus.InfiniteOptions> = {}) {
        return this.each(function () {
            var $element = $(this);
            if (!$element.data(pluginName)) {
                $element.data(pluginName, new Bookhus.InfiniteScroll($element, options));
            }
        });
    };
})(jQuery);
